import { config, googleSignInUrl } from '../../config.js';

/** Story #4 — hands off to the Cognito hosted UI for the Google redirect. */
export function GoogleButton({ label }: { label: string }) {
  // Hidden unless the pool really has a Google provider. Checking only for a
  // Cognito domain is not enough: the domain exists on every deployment, so
  // the button would appear and dead-end on the hosted UI.
  if (!config.googleEnabled || !config.cognitoDomain || !config.userPoolClientId) return null;

  const redirectUri = `${window.location.origin}/auth/callback`;

  return (
    <>
      <div className="divider">
        <span>or</span>
      </div>
      <a className="button secondary block" href={googleSignInUrl(redirectUri)}>
        {label}
      </a>
    </>
  );
}
